const timeUtils = { 

  getShortTime: function(timeString) {
    return timeString.toString().substr(0, timeString.lastIndexOf(":"));
  },

  humanize: (timeString) => {
    return timeString
  },
  getDurationTime: function(durationString) {
    let msec = Number(durationString)
    // add 499 ms in order to round up seconds to an integer as needed
    msec += 499;
    let sec = msec / 1000;
    let min = sec / 60;
    min = min | 0
    sec = sec % 60;
    sec = sec | 0
    let secStr = sec > 9 ? "" + sec: "0" + sec 
    let minStr = min > 9 ? "" + min: "0" + min 
    return minStr + ":" + secStr
  },

  secondsToTime: function(seconds) {
    let date = new Date(seconds * 1000)
    let hh = date.getUTCHours()
    let mm = date.getUTCMinutes()
    let ss = date.getSeconds()

    if (hh == 0)
      hh = ''
    else if (hh < 10)
      hh = "0" + hh
    if (hh != '') hh += ':'

    if (mm < 10) mm = "0" + mm
    if (ss < 10) ss = "0" + ss

    return hh + mm + ":" + ss
  }
}

export default timeUtils